<template>
  <div id="modalCreateLabel" class="modal fade">
    <div class="modal-dialog modal-dialog-vertical-center modal-md" role="document">
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="loading"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{data ? $t('express.修改标签') : $t('express.新增标签')}}</h6>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25 tx-center tx-16 model-auto-h">
          <div class="form-group row">
            <label for="iptLabelName" class="col-md-3 col-sm-12 col-form-label form-control-sm text-right">{{$t("express.标签名：")}}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-md-7 col-sm-12">
              <input type="text" class="form-control form-control-sm" name="name" id="iptLabelName" v-model.trim="name">
            </div>
          </div>
          <div v-if="loginType == '2' && $route.meta.url != '/express'" class="form-group row">
            <label class="col-md-3 col-sm-12 col-form-label form-control-sm text-right">{{$t("express.标签类型：")}}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-md-7 col-sm-8">
              <select class="form-control form-control-sm" v-model="type">
                <option value="">{{$t("express.请选择类型")}}</option>
                <option v-for="(type, i) in labelType" :value="i" :key="i">{{$t(type)}}</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-sm-12 col-form-label form-control-sm text-right">{{$t("express.规格：")}}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-md-7 col-sm-8">
              <select class="form-control form-control-sm" v-model="specType" :disabled="data">
                <option value="">{{$t("express.请选择规格")}}</option>
                <option v-for="(specType, i) in labelSpecType" :value="i" :key="i">{{i == 99 ? $t(specType) : specType}}</option>
              </select>
            </div>
          </div>
          <div v-show="specType == '99'" class="form-group row">
            <div class="col-md-3 col-sm-12"></div>
            <div class="col-md-7 col-sm-12 row">
              <div class="col-6 d-flex align-items-center">
                <span class=" mg-r-5">{{$t("express.宽:")}}</span>
                <input type="text" class="form-control form-control-sm mg-r-5" :disabled="data" v-model.number="specWidth">
                <span>mm</span>
              </div>
              <div class="col-6 d-flex align-items-center">
                <span class=" mg-r-5">{{$t("express.高:")}}</span>
                <input type="text" class="form-control form-control-sm mg-r-5" :disabled="data" v-model.number="specHeight">
                <span>mm</span>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-sm-12 col-form-label form-control-sm text-right">{{$t("express.状态：")}}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-md-7 col-sm-12">
              <select class="form-control form-control-sm" v-model="status">
                <option v-for="(status, k) in labelStatus" :key="k" :value="k">{{$t(status)}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" @click="save">{{$t("express.保存")}}</button>
          <button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal">{{$t("express.关闭")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "data"],
  data() {
    return {
      loginType: localStorage.getItem('loginType'),
      loading: false,
      labelType: arrDict.labelType,
      labelSpecType: arrDict.labelSpecType,
      labelStatus: arrDict.labelStatus,
      name: "",
      specType: "",
      type: '',
      specWidth: "",
      specHeight: "",
      status: 1
    };
  },
  created() {
    if(localStorage.getItem('loginType') == '1') this.type = '2'
    if(this.$route.meta.url == '/express') this.type = '1'
  },
  watch: {
    open: function() {
      //重置数据
      if (this.data) {
        (this.name = this.data.name),
          (this.specType = this.data.specType),
          (this.type = this.data.type),
          (this.specWidth = this.data.specWidth),
          (this.specHeight = this.data.specHeight),
          (this.status = this.data.status);
      } else {
        (this.name = ""),
          (this.specType = ""),
          (this.type = ''),
          (this.specWidth = ""),
          (this.specHeight = ""),
          (this.status = 1);
      }
      if(localStorage.getItem('loginType') == '1') this.type = '2';
      if(this.$route.meta.url == '/express') this.type = '1';
    }
  },
  methods: {
    save() {
      if (!this.name) {
        ShowTip(this.$t('express.标签名必须输入'), "danger");
        return;
      }
      if (!this.specType) {
        ShowTip(this.$t('express.必须选择一个规格'), "danger");
        return;
      }
      if (this.specType == "99" && !(this.specWidth && this.specHeight)) {
        ShowTip(this.$t('express.自定义规格必须输入宽高'), "danger");
        return;
      }
      if (!this.type) {
        ShowTip(this.$t('express.必须选择一个标签类型'), "danger");
        return;
      }
      let params = {
        id: this.data ? this.data.id : '',
        name: this.name,
        specType: this.specType,
        type: this.type,
        specWidth: this.specWidth,
        specHeight: this.specHeight,
        status: this.status
      };
      let newW = "";
//    if(this.data){
//    	newW = "";
//    }else{
//    	newW = window.open("/blank.html", "savePrintTpl", undefined, true);
//    }
      $.api_call("api.PrintLabel.savePrintTpl", params, r => {
        if (r.ErrorCode == "9999") {
          this.$emit("changeSuccess", this.data ? this.data.id : undefined);
          if(this.data){
		      	newW = "";
		      }else{
		      	newW = window.open("/blank.html", "savePrintTpl", undefined, true);
		      	newW.location = `/print/print.html?id=${r.Data.Results.id}`;
		      }
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    }
  }
};
</script>
